import React, { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import Config from "../../config";

const SurveyPopup = (props) => {
  const [visible, setVisible] = useState(false);
  const SurveyPreference = localStorage.getItem("SurveyPreference");
  const HoursSinceLastLogin = localStorage.getItem("HoursSinceLastLogin");
  const IsSurveyPopupActive = localStorage.getItem("IsSurveyPopupActive");
  useEffect(() => {
    // Update the document title using the browser API
    if(IsSurveyPopupActive == "true"){
    if (SurveyPreference == 1) {
      // Don't wish to participate
      setVisible(false);
    } else if (SurveyPreference == 2) {
      // "taken servey"
      setVisible(false);
    } else if (SurveyPreference == 3 && HoursSinceLastLogin > 24) {
      // "Remind me later"
      setVisible(true);
    } else if (SurveyPreference == 0) {
      // not yet ans or popup not answered
      setVisible(true);
    } else {
      setVisible(false);
    }}
  }, []);
  const handleSubmit = (val) => {
    // Make the API call with the payload
    fetch(Config.api + "/SetSurveyPreference", {
      method: "POST",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Preference: val,
        Email: sessionStorage.getItem("userEmail"),
        TenantID: sessionStorage.getItem("Tanent"),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Process the API response as needed
        console.log("data", data);
        if (val == 0) {
          val = 4;
        }
        localStorage.setItem("SurveyPreference", val);
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
      });
  };

  const handleTakeSurvey = () => {
    // Logic for "Take Survey" option
    window.open(localStorage.getItem("SurveyLink"), "_blank");
    setVisible(false);
    handleSubmit(2);
  };

  const handleRemindLater = () => {
    // Logic for "Remind Me Later" option
    setVisible(false);
    handleSubmit(3);
  };

  const handleNotParticipate = () => {
    // Logic for "Don't Wish to Participate" option
    setVisible(false);
    handleSubmit(1);
  };
  const handleCLickOutside = () => {
    // Logic for "Don't Wish to Participate" option
    // setVisible(false);
    // handleSubmit(0);
    console.log("Select anyone")
  };

  return (
    <Modal
      open={visible}
      closable={false}
      title="2025 Provider Satisfaction Survey"
      onCancel={handleCLickOutside}
      footer={[
        <Button key="take" type="primary" onClick={handleTakeSurvey}>
          Take Survey
        </Button>,
        <Button key="remind" onClick={handleRemindLater}>
          Remind Me Later
        </Button>,
        <Button key="notParticipate" onClick={handleNotParticipate}>
          Don't Wish to Participate
        </Button>,
      ]}
    >
      {/* Survey content goes here */}
      <p>
        Thank you for your participation with the Ultimate Network! Would you be willing to take a brief satisfaction survey?
      </p>
    </Modal>
  );
};

export default SurveyPopup;
